// extracted by mini-css-extract-plugin
export default {"campaignInitialisation":"CampaignInitialisation_campaignInitialisation__xoiQv","formWrapper":"CampaignInitialisation_formWrapper__-+-O2"};